module.exports = __webpack_public_path__ + "static/results-cbbc7ff9e166579f2406f26c40fe3bcd.png";